module.exports = __webpack_public_path__ + "static/media/thanks-for.bc65be10.svg";